import { Box, Stack, TextField, Tooltip, Typography, Autocomplete, IconButton, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { useHistory } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Loader from '../../../../Components/Loader'
import { localGetItem } from '../../../../Utility/Services/CacheProviderService'



export default function AddApprovers() {
    const history = useHistory();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [formState, setFormState] = useState({
        UserNameList: [],
        ApproverList: [],
        SelectedUser: null,
        SelectedCounter: [],
        selectedId: null,
        AllUserList: [],
        CounterList: [],
    });
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isloader, setisloader] = useState(false);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);

    const CounterList = [
    { id: '', label: 'All' },
    { id: 'FO', label: 'Front Office' },
    { id: 'LAB', label: 'Laboratory' },
    { id: 'RAD', label: 'Radiology' },
        ...localGetItem("Investigation_List") ? JSON.parse(localGetItem("Investigation_List"))?.map((list) => {
            return { id: list, label: list }
        }) : []
    ]

    useEffect(() => {
        getUserNameList();
        getApproverList();
    }, []);

    const getUserNameList = () => {
        try {
            setisloader(true);
            RestAPIService.getAll(Serviceurls.USER_ACCESS_SPECIFIC_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const users = response?.data?.data || [];
                        const filteredUsers = users?.filter(user => {
                            const modules = Array.isArray(user.clinic_access) ? user.clinic_access : [];

                            const frontOffice = modules?.find(m => m?.module_type === "front_office");
                            const radiology = modules?.find(m => m?.module_type === "Radiology");
                            const laboratory = modules?.find(m => m?.module_type === "Laboratory");
                            const investigation = modules?.filter(m =>( m?.module_type === "Investigation" && m?.title));

                            let allTabs = [];

                            if (frontOffice) {
                                const sub = frontOffice?.data?.find(d => d?.title === "Hospital Billing");
                                if (sub?.main_tabs) allTabs.push(...sub?.main_tabs);
                            }

                            if (radiology) {
                                const sub = radiology?.data?.find(d => d?.title === "Radiology Billing");
                                if (sub?.main_tabs) allTabs?.push(...sub?.main_tabs);
                            }

                            if (laboratory) {
                                const sub = laboratory?.data?.find(d => d?.title === "Lab Billing");
                                if (sub?.main_tabs) allTabs?.push(...sub?.main_tabs);
                            }
                            if (investigation?.length) {
                                investigation?.forEach((inv) => {
                                    const sub = inv?.data?.find(d => d?.title === "Investigation Billing");
                                    if (sub?.main_tabs) {
                                        allTabs?.push(...sub?.main_tabs);
                                    }
                                })
                            }

                            const hasCashCounter = allTabs?.some(t => t?.title === "Cash Counter" && t?.editAccess);
                            const hasHospitalBilling = allTabs?.some(t => t?.title === "Hospital Billing" && t?.editAccess);

                            const hasCashCounterPermission = user?.user_access_data?.common?.cash_counter === true;

                            return (hasCashCounter && hasHospitalBilling && hasCashCounterPermission) || (user?.is_super_admin && user?.role_name !== "PHARMACY");
                        });

                        setFormState((prevState) => ({
                            ...prevState,
                            UserNameList: filteredUsers,
                            AllUserList: users
                        }));
                    }
                    setisloader(false);
                })
                .catch(e => {
                    setisloader(false);
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message);
                    } else {
                        errorMessage(e.message);
                    }
                });
        } catch (e) {
            setisloader(false);
            errorMessage(e.message);
        }
    };

    const getApproverList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.USER_ACCESS_ADD_APPROVER).
                then((response) => {
                    if (response.data.status === 'success') {
                        setFormState((prevState) => ({
                            ...prevState,
                            ApproverList: response.data.data || [],
                        }));
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const onChangeAuto = (e, val, name) => {
        if (name === 'SelectedCounter') {
            let updatedValue = [];

            if (val?.some(item => item.id === '')) {
                updatedValue = [{ id: '', label: 'All' }];
            } else {
                updatedValue = val.filter(item => item.id !== '');
            }

            setFormState((prevState) => ({
                ...prevState,
                [name]: updatedValue,
            }));
        } else if (name === 'SelectedUser') {
            let selectedCounters = extractCountersFromUser(val, CounterList);
            if (val?.is_super_admin && val?.role_name !== "PHARMACY") {
                selectedCounters = CounterList;
            }
            setFormState((prevState) => ({
                ...prevState,
                [name]: val,
                CounterList: selectedCounters,
            }));
        }
    };

    const extractCountersFromUser = (user, fullCounterList) => {
        const allowedCounters = new Set();

        const clinicAccessList = Array.isArray(user?.clinic_access) ? user?.clinic_access : Object.values(user?.clinic_access || {});
        clinicAccessList.forEach((module) => {
            const { module_type, data } = module;

            const expectedBillingTitle = {
                front_office: 'Hospital Billing',
                Radiology: 'Radiology Billing',
                Laboratory: 'Lab Billing',
                Investigation : "Investigation Billing"
            }[module_type];

            if (!expectedBillingTitle || !Array.isArray(data)) return;

            const billingSection = data?.find(d => (expectedBillingTitle === 'Investigation Billing' ? (d.title === expectedBillingTitle && module?.title) : (d.title === expectedBillingTitle)));
            const main_tabs = billingSection?.main_tabs || [];

            const hasHospitalBilling = main_tabs.some(t => typeof t === 'object' && t?.title === 'Hospital Billing' && t?.editAccess);
            const hasCashCounter = main_tabs.some(t => typeof t === 'object' && t?.title === 'Cash Counter' && t?.editAccess);


            if (hasHospitalBilling && hasCashCounter) {
                if (module_type === 'front_office') allowedCounters.add('FO');
                if (module_type === 'Laboratory') allowedCounters.add('LAB');
                if (module_type === 'Radiology') allowedCounters.add('RAD');
                if( module_type === 'Investigation' && module?.department) allowedCounters.add(module?.department);
            }
        });

        let finalCounters = fullCounterList?.filter(counter => allowedCounters?.has(counter?.id));

        if (finalCounters?.length > 2) {
            finalCounters = [{ id: '', label: 'All' }, ...finalCounters];
        }

        return finalCounters;
    };

    const autoComplete = (label, name, val, list, width) => {
        return (
            <Box>
                <Autocomplete
                    clearIcon
                    multiple={name === 'SelectedCounter'}
                    limitTags={1}
                    disabled={(name === 'SelectedUser' && formState?.selectedId) || (name === 'SelectedCounter' && formState?.SelectedUser === null)}
                    size={'small'}
                    options={list}
                    name={name}
                    getOptionLabel={(option) => {
                        if (name === 'SelectedUser') {
                            return `${option?.user_name || ''}`
                        } else if (name === 'SelectedCounter') {
                            return option?.label
                        } else {
                            return '';
                        }
                    }}
                    getOptionDisabled={(option) => {
                        if (name !== 'SelectedCounter') return false;

                        const selected = formState?.SelectedCounter || [];

                        if (selected.some((item) => item.id === '')) {
                            return option.id !== '';
                        } else if (selected.length > 0) {
                            return option.id === '';
                        }
                        return false;
                    }}
                    value={val}
                    onChange={(event, newValue) => { onChangeAuto(event, newValue, name) }}
                    renderInput={(params) => <TextField {...params} label={label} sx={{ width: width, marginRight: '0.3vw' }} />}
                />
            </Box>
        )
    }

    const handleEdit = (row) => {
        const selectedUser = formState?.UserNameList?.find(user => user?.login_id === row?.login_user_id) || null;
        let userCounterList = extractCountersFromUser(selectedUser, CounterList);
        if (selectedUser?.is_super_admin && selectedUser?.role_name !== "PHARMACY") {
            userCounterList = CounterList;
        }

        setFormState((prevState) => ({
            ...prevState,
            SelectedUser: selectedUser,
            SelectedCounter: userCounterList?.filter(counter => {
                if (row?.is_frontoffice && counter.id === 'FO') return true;
                if (row?.is_laboratory && counter.id === 'LAB') return true;
                if (row?.is_radiology && counter.id === 'RAD') return true;
                if (row?.is_all && counter.id === '') return true;
                return false;
            }),
            CounterList: userCounterList,
            selectedId: row?.id || null
        }));
    };

    const tableView = () => {

        const grpDelete = () => {
            setisDelete(true)
        }

        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = formState?.ApproverList?.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        formState?.ApproverList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'login_user_name', headerName: 'Username', flex: 0.18,
                renderCell: (params) => (params.row?.login_user_name && params.row?.login_user_name?.length > 70 ?
                    <Tooltip placement="top" title={`${params.row.login_user_name}`}>
                        <Typography fontSize={'0.9vw'}>{params.row.login_user_name.slice(0, 67) + '...'}</Typography>
                    </Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.login_user_name || '-'}</Typography>)
            },
            {
                field: 'counter', headerName: 'Counter', flex: 0.18,
                renderCell: (params) => {
                    const counterValue = Array.isArray(params.row.counter) ? params.row?.counter.join(', ') : params.row?.counter;
                    return (counterValue && counterValue?.length > 70 ?
                        <Tooltip placement="top" title={`${counterValue}`}>
                            <Typography fontSize={'0.9vw'}>{counterValue.slice(0, 67) + '...'}</Typography>
                        </Tooltip> :
                        <Typography fontSize={'0.9vw'}>{counterValue || '-'}</Typography>)
                }
            },
            {
                field: 'action', headerName: 'Action', flex: 0.25, align: 'center', headerAlign: 'center',
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw" onClick={() => { handleEdit(params.row) }} />
                        </Stack>
                    </Stack>)
            }
        ];
        return (
            <Box sx={{ height: '60vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection={true}
                    selectionModel={CheckBoxList}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={formState?.ApproverList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const AddApproverData = () => {
        try {
            if (!formState?.SelectedUser) {
                return errorMessage('Select User Name')
            } else if (formState?.SelectedCounter?.length === 0) {
                return errorMessage('Select Counter')
            }
            let Selected_Investigation_List = [];
            if (localGetItem("Investigation_List")) {
                JSON.parse(localGetItem("Investigation_List"))?.forEach((list) => {
                    if (formState?.SelectedCounter?.some((counter) => counter?.label === list || counter?.label === 'All')) {
                        Selected_Investigation_List.push(list);
                    }
                });
            }
            let data = {
                'login_user_id': formState?.SelectedUser?.login_id || null,
                'is_frontoffice': formState?.SelectedCounter?.some(counter => counter?.label === 'Front Office' || counter?.label === 'All') ? true : false,
                'is_laboratory': formState?.SelectedCounter?.some(counter => counter?.label === 'Laboratory' || counter?.label === 'All') ? true : false,
                'is_radiology': formState?.SelectedCounter?.some(counter => counter?.label === 'Radiology' || counter?.label === 'All') ? true : false,
                'investigation_details': Selected_Investigation_List,
                'id': formState?.selectedId || null,
            }
            setisloader(true)
            RestAPIService.create(data, Serviceurls.USER_ACCESS_ADD_APPROVER)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        successMessage(response.data.message)
                        setFormState((prevState) => ({
                            ...prevState,
                            SelectedUser: null,
                            SelectedCounter: [],
                            selectedId: null
                        }));
                        getApproverList()
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const deleteApprover = async () => {
        try {
            setisloader(true)
            RestAPIService.delete(`${Serviceurls.USER_ACCESS_ADD_APPROVER}?del_ids=${delIDs}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        closeFilter()
                        getApproverList()
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const closeFilter = () => {
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const prevent = () => {
        history.push("/Settings/UserConfig/ApproverConfiguration")
    }

    return (
        <Box component={'div'} sx={{ height: '85vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray' }}>
                <IconButton onClick={() => { prevent() }}>
                    <ChevronLeftIcon color='primary' />
                </IconButton>
                <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Back To Approver Configuration'}</Typography>
            </Box>

            <Box component={'div'} sx={{ height: '14vh', width: '93vw', backgroundColor: 'white', mt: "1vw" }}>
                <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray', paddingLeft: "0.5vw" }}>
                    <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Concession'}</Typography>
                </Box>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between", alignItems: "center", height: "9vh", paddingLeft: "0.5vw" }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", height: "9vh", paddingLeft: "0.5vw" }}>
                        {autoComplete("Select User", 'SelectedUser', formState?.SelectedUser, formState?.UserNameList, '25vw')}
                        {autoComplete("Select Counter", 'SelectedCounter', formState?.SelectedCounter, formState?.CounterList, '25vw')}
                        <Button variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '0.5vw' }} onClick={() => { AddApproverData() }}>Add</Button>
                    </div>
                </Box>
            </Box>

            <Box component={'div'} sx={{ height: '60vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white' }}>
                {tableView()}
            </Box>

            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to delete this user ?`}
                    DeleteNotify={"If you remove this, this could be effect in entire Configuration"}
                    deleteAlertPopupClose={closeFilter}
                    removeData={deleteApprover}
                />
                : null}
            <Loader loaderOpen={isloader} />
        </Box>
    )
}